'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _DependentComponent = require('./DependentComponent');

var _DependentComponent2 = _interopRequireDefault(_DependentComponent);

var _SubSectionHeaderComponent = require('./SubSectionHeaderComponent');

var _SubSectionHeaderComponent2 = _interopRequireDefault(_SubSectionHeaderComponent);

var _DatePickerComponent = require('../input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _CurrencyInputComponent = require('../input/CurrencyInputComponent');

var _CurrencyInputComponent2 = _interopRequireDefault(_CurrencyInputComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a single additional applicant component for the form.
 */

var MshApplicantComponent = function MshApplicantComponent(_ref) {
  var applicant = _ref.applicant,
      showNamesAndGender = _ref.showNamesAndGender,
      showOccupation = _ref.showOccupation,
      showDependents = _ref.showDependents,
      formConfig = _ref.formConfig,
      dynamicFieldIndex = _ref.dynamicFieldIndex,
      inputComponentField = _ref.inputComponentField,
      rotationalBasis = _ref.rotationalBasis,
      medicalPlanOptions = _ref.medicalPlanOptions,
      dentalPlanOptions = _ref.dentalPlanOptions,
      salaryFrequency = _ref.salaryFrequency,
      email = _ref.email,
      phone = _ref.phone,
      onChangeHook = _ref.onChangeHook,
      setDepCount = _ref.setDepCount,
      checkError = _ref.checkError,
      formValues = _ref.formValues,
      dates = _ref.dates,
      isGroupForm = _ref.isGroupForm,
      applicantIndex = _ref.applicantIndex,
      formName = _ref.formName;

  var dateRestrictions = dates(formValues);
  var countries = formConfig['applicant.additional_data.home_country'].component_props.options;
  return _react2.default.createElement(
    'div',
    { className: 'applicant-info' },
    _react2.default.createElement(
      _SubSectionHeaderComponent2.default,
      null,
      (0, _translate.t)('Applicant') + ' ' + (dynamicFieldIndex + 1)
    ),
    showNamesAndGender ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'applicantFirstName',
        inputLabel: (0, _translate.t)('First Name'),
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.first_name,
        inputComponentProps: {
          type: 'text'
        },
        dynamicFieldIndex: dynamicFieldIndex,
        hasError: checkError('applicant.' + dynamicFieldIndex + '.first_name')
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'applicantLastName',
        inputLabel: (0, _translate.t)('Last Name'),
        inputComponent: _TextInputComponent2.default,
        inputComponentField: inputComponentField.last_name,
        inputComponentProps: {
          type: 'text'
        },
        dynamicFieldIndex: dynamicFieldIndex,
        hasError: checkError('applicant.' + dynamicFieldIndex + '.last_name')
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'applicantGender',
        inputLabel: (0, _translate.t)('Gender'),
        inputComponent: _SelectComponent2.default,
        inputComponentField: inputComponentField.gender,
        inputComponentProps: {
          options: formConfig['applicant.gender'].component_props.options,
          onChangeHook: onChangeHook
        },
        dynamicFieldIndex: dynamicFieldIndex,
        hasError: checkError('applicant.' + dynamicFieldIndex + '.gender')
      })
    ) : null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'additionalApplicantDob',
      inputLabel: (0, _translate.t)('Date of Birth'),
      inputComponent: _DatePickerComponent2.default,
      inputComponentField: inputComponentField.dob,
      inputComponentProps: {
        placeholderText: (0, _translate.t)('Please select a date...'),
        showYearDropdown: true,
        showMonthDropdown: true,
        minDate: dateRestrictions.applicants.dob.min,
        maxDate: dateRestrictions.applicants.dob.max,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.dob')
    }),
    email ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantEmail',
      inputLabel: (0, _translate.t)('Email'),
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.additional_data.email,
      inputComponentProps: {
        type: 'text'
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.email')
    }) : null,
    phone ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantPhone',
      inputLabel: (0, _translate.t)('Phone Number'),
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.additional_data.phone,
      inputComponentProps: {
        type: 'text'
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.phone')
    }) : false,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantSalary',
      inputLabel: salaryFrequency ? (0, _translate.t)('Salary') : (0, _translate.t)('Annual Salary'),
      inputComponent: _CurrencyInputComponent2.default,
      inputComponentField: inputComponentField.additional_data.salary,
      inputComponentProps: {
        type: 'text'
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.salary')
    }),
    salaryFrequency ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantSalaryFrequency',
      inputLabel: (0, _translate.t)('Salary Frequency'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.salary_frequency,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.salary_frequency'].component_props.options,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.salary_frequency')
    }) : null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantCurrency',
      inputLabel: (0, _translate.t)('Currency'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.currency,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.currency'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.currency')
    }),
    showOccupation ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantOccupation',
      inputLabel: (0, _translate.t)('Occupation'),
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.additional_data.occupation,
      inputComponentProps: {
        type: 'text'
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.occupation')
    }) : null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantOccupationalClass',
      inputLabel: (0, _translate.t)('Occupational Class for LTD'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.occupational_class,
      inputComponentProps: {
        options: [{ value: 1, text: '1' }, { value: 2, text: '2' }, { value: 3, text: '3' }, { value: 4, text: '4' }],
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: true,
      expandableHintId: 'applicantOccupationalClassHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['applicant.additional_data.occupation_class'].hint,
      expandableHintIsRawHtml: true,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.occupational_class')
    }),
    formName === 'global2go' && formValues.application.additional_data.voluntary_adnd_insurance_amount && formValues.application.additional_data.voluntary_adnd_insurance_amount > 0 && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantOccupationalClassVoluntary',
      inputLabel: (0, _translate.t)('Occupational Class for Voluntary AD&D'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.occupational_class_voluntary_adnd,
      inputComponentProps: {
        options: [{ value: 'class1', text: '1' }, { value: 'class2', text: '2' }, { value: 'class3', text: '3' }, { value: 'class4', text: '4' }, { value: 'class5', text: '5' }],
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: true,
      expandableHintId: 'applicantOccupationalClassVoluntaryHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['applicant.additional_data.occupation_class_voluntary_adnd'].hint,
      expandableHintIsRawHtml: true,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.occupation_class_voluntary_adnd')
    }),
    isGroupForm === undefined || !isGroupForm || formValues.application.additional_data.dependent_medical_coverage === '1' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantPolicyType',
      inputLabel: (0, _translate.t)('Type of Coverage'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.policy_type,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.policy_type'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.policy_type')
    }) : null,
    medicalPlanOptions && medicalPlanOptions.value === '1' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantMedicalPlan',
      inputLabel: (0, _translate.t)('Medical Plan'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.medical_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.medical_coverage'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: true,
      expandableHintId: 'applicantMedicalCoverageHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['application.additional_data.medical_coverage'].hint,
      expandableHintIsRawHtml: false,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.medical_coverage')
    }) : null,
    dentalPlanOptions && dentalPlanOptions.value === '1' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantDentalPlan',
      inputLabel: (0, _translate.t)('Dental Plan'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.dental_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.dental_coverage'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: true,
      expandableHintId: 'applicantDentalCoverageHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['application.additional_data.dental_coverage'].hint,
      expandableHintIsRawHtml: false,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.dental_coverage')
    }) : null,
    dentalPlanOptions && dentalPlanOptions.value === '1' && applicant.additional_data.policy_type.value === 'family' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantDentalPlan',
      inputLabel: (0, _translate.t)('Orthodonia'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.orthodontia_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.orthodontia_coverage'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: true,
      expandableHintId: 'applicantOrthodontiaHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['applicant.additional_data.orthodontia_coverage'].hint,
      expandableHintIsRawHtml: true,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.orthodontia_coverage')
    }) : null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantHomeCountry',
      inputLabel: (0, _translate.t)('Home Country'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.home_country,
      inputComponentProps: {
        options: countries,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.home_country')
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantHostCountry',
      inputLabel: (0, _translate.t)('Host Country'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.host_country,
      inputComponentProps: {
        options: countries,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.host_country')
    }),
    rotationalBasis ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantRotation',
      inputLabel: formConfig['applicant.additional_data.rotational_basis'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.rotational_basis,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.rotational_basis'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.rotational_basis')
    }) : null,
    rotationalBasis && applicant.additional_data.rotational_basis.value === '1' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantExposurePeriod',
      inputLabel: (0, _translate.t)('Exposure Period'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.exposure_period,
      inputComponentProps: {
        options: formConfig['application.additional_data.exposure_period'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.exposure_period')
    }) : null,
    !rotationalBasis || applicant.additional_data.rotational_basis.value === '0' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantGeographicalCoverage',
      inputLabel: formConfig['applicant.additional_data.worldwide_coverage'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.worldwide_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.worldwide_coverage'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: formConfig['applicant.additional_data.worldwide_coverage'].hint,
      expandableHintId: 'applicantWorlwideCoverageHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['applicant.additional_data.worldwide_coverage'].hint,
      expandableHintIsRawHtml: true,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.worldwide_coverage')
    }) : null,
    rotationalBasis && applicant.additional_data.rotational_basis.value !== '0' ? _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'applicantGeographicalCoverage',
      inputLabel: formConfig['applicant.additional_data.worldwide_coverage_rotational'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.worldwide_coverage,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.worldwide_coverage_rotational'].component_props.options,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasExpandableHint: formConfig['applicant.additional_data.worldwide_coverage'].hint,
      expandableHintId: 'applicantWorlwideCoverageHint',
      expandableHintTitle: '',
      expandableHintContent: formConfig['applicant.additional_data.worldwide_coverage'].hint,
      expandableHintIsRawHtml: true,
      hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.worldwide_coverage')
    }) : null,
    showDependents && isGroupForm !== undefined && !isGroupForm && applicant.additional_data.policy_type.value !== 'single' ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'dependentCount',
        inputLabel: (0, _translate.t)('Number of Dependents'),
        inputComponent: _SelectComponent2.default,
        inputComponentField: inputComponentField.additional_data.dependent_count,
        inputComponentProps: {
          options: formConfig['applicant.additional_data.dependent_count'].component_props.options,
          onChangeHook: setDepCount.bind(undefined, applicantIndex)
        },
        dynamicFieldIndex: dynamicFieldIndex,
        hasError: checkError('applicant.' + dynamicFieldIndex + '.additional_data.dependent_count')
      }),
      inputComponentField.additional_data.dependents.map(function (element, index) {
        return _react2.default.createElement(_DependentComponent2.default, {
          applicant: element,
          key: index,
          dynamicFieldIndex: index,
          inputComponentField: element,
          formConfig: formConfig,
          onChangeHook: onChangeHook,
          checkError: checkError,
          formValues: formValues,
          dates: dates
        });
      })
    ) : null
  );
};

MshApplicantComponent.propTypes = {
  applicant: _react2.default.PropTypes.object.isRequired,
  showNamesAndGender: _react2.default.PropTypes.bool,
  showOccupation: _react2.default.PropTypes.bool,
  showDependents: _react2.default.PropTypes.bool,
  dynamicFieldIndex: _react2.default.PropTypes.number.isRequired,
  inputComponentField: _react2.default.PropTypes.object.isRequired,
  rotationalBasis: _react2.default.PropTypes.bool,
  medicalPlanOptions: _react2.default.PropTypes.object,
  dentalPlanOptions: _react2.default.PropTypes.object,
  salaryFrequency: _react2.default.PropTypes.bool,
  isGroupForm: _react2.default.PropTypes.bool,
  applicantIndex: _react2.default.PropTypes.number,
  email: _react2.default.PropTypes.bool,
  phone: _react2.default.PropTypes.bool,
  onChangeHook: _react2.default.PropTypes.func,
  setDepCount: _react2.default.PropTypes.func,
  checkError: _react2.default.PropTypes.func,
  formValues: _react2.default.PropTypes.object.isRequired,
  dates: _react2.default.PropTypes.func.isRequired,
  formConfig: _react2.default.PropTypes.object,
  formName: _react2.default.PropTypes.string.isRequired
};

exports.default = MshApplicantComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/MshApplicantComponent.jsx
// module id = 397
// module chunks = 0